import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';
import { UserFeatureToggleStateType } from 'reducers/userFeatureToggleReducer';

export const selectUserFeatureToggles = createSelector(
  (state: GlobalState) => state.userFeatureToggles,
  (toggles: UserFeatureToggleStateType) => toggles.features,
);
